import script from "./downloadHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./downloadHistory.vue?vue&type=script&setup=true&lang=js"

import "./downloadHistory.vue?vue&type=style&index=0&id=d9b598c8&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9b598c8"]])

export default __exports__